import { styled } from '@mui/material/styles';
import { Grid, TableCell } from '@mui/material';
import { TextField } from '../../atoms/TextField';

export const StyledGridContainer = styled(Grid)`
  padding-top: 5px;
`;

export const StyledTableCell = styled(TableCell)((props: { depth?: number }) =>`
  border: 0;
  justify-content: flex-end;
  padding-left: ${(props?.depth || 0) * 30}px;
`);

export const StyledGreyTextField = styled(TextField)`
  background-color: #DCDCDC;
  color: black;
`;